"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFieldMessage = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _useSanitizedHTML = require("../../../hooks/useSanitizedHTML/useSanitizedHTML");
var _react = _interopRequireDefault(require("react"));
var _formFieldMessageModule = _interopRequireDefault(require("./form-field-message.module.scss"));
var FormFieldMessage = function FormFieldMessage(_ref) {
  var submitted = _ref.submitted,
    errorMessage = _ref.errorMessage,
    instruction = _ref.instruction,
    errorClassName = _ref.errorClassName,
    instructionClassName = _ref.instructionClassName;
  var shouldShowError = submitted && errorMessage;
  var sanitizedInstruction = (0, _useSanitizedHTML.useSanitizedHTML)(instruction);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, shouldShowError && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_formFieldMessageModule.default['form-field-error'], errorClassName)
  }, errorMessage), instruction && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_formFieldMessageModule.default['form-field-instruction'], instructionClassName),
    dangerouslySetInnerHTML: {
      __html: sanitizedInstruction
    }
  }));
};
exports.FormFieldMessage = FormFieldMessage;